import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('/page/index.vue')
const Zhibo = () => import('/page/Videozhibo/zhibo.vue')
const Lectureroom = () => import('/page/Videozhibo/lectureroom.vue')
const Videoplay = () => import('/page/Videozhibo/videoplay.vue')
const Index2 = () => import('/page/Index/index.vue')
const NewMessage = () => import('/page/Index/newMessage.vue')
const Jinghua = () => import('/page/Jinghua/jinghua.vue')
const Understand = () => import('/page/Master/understand.vue')
const Ebook = () => import('/page/ebook/index.vue')
const EbookList = () => import('/page/ebook/ebooklist.vue')
const BookInfo = () => import('/page/ebook/bookinfo.vue')
const MoIndex = () => import('/page/mobao/moIndex.vue')
const DeskIndex = () => import('/page/mobao/deskIndex.vue')
const DeskIndexnew = () => import('/page/mobao/deskIndexnew.vue')
const Sharepage = () => import('/page/Videozhibo/sharepage.vue')
const Privacy = () => import('/page/Index/privacy.vue')

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      name: 'index',
      redirect: '/home',
      children: [
        {path: 'home',
          name: 'home',
          component: Index2,
          meta: {
            metaInfo: {
              title: '淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'livetv',
          name: 'livetv',
          component: Zhibo,
          meta: {
            metaInfo: {
              title: '直播台｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網直播台24小時全天直播',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }
        },
        {path: 'videoplay',
          name: 'videoplay',
          component: Videoplay,
          meta: {
            metaInfo: {
              title: '视频点播｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網视频点播',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'understand',
          name: 'understand',
          component: Understand,
          meta: {
            metaInfo: {
              title: '認識法師｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網認識法師',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'newMessage',
          name: 'newMessage',
          component: NewMessage,
          meta: {
            metaInfo: {
              title: '直播台｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網直播台24小時全天直播',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'jinghua',
          name: 'jinghua',
          component: Jinghua,
          meta: {
            metaInfo: {
              title: '菁華開示｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網菁華開示',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'ebook',
          name: 'ebook',
          component: Ebook,
          meta: {
            metaInfo: {
              title: '講記著作｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網電子書',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'ebooklist',
          name: 'ebooklist',
          component: EbookList,
          meta: {
            metaInfo: {
              title: '講記著作｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網電子書',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'bookInfo',
          name: 'bookInfo',
          component: BookInfo,
          meta: {
            metaInfo: {
              title: '講記著作｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網電子書',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'moIndex',
          name: 'moIndex',
          component: MoIndex,
          meta: {
            metaInfo: {
              title: '墨寶｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網墨寶',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'deskIndexold',
          name: 'deskIndexold',
          component: DeskIndex,
          meta: {
            metaInfo: {
              title: '卡片｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網卡片',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'deskIndex',
          name: 'deskIndex',
          component: DeskIndexnew,
          meta: {
            metaInfo: {
              title: '卡片｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網卡片',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }},
        {path: 'lectureroom',
          name: 'lectureroom',
          component: Lectureroom,
          meta: {
            metaInfo: {
              title: '報恩講堂｜淨空老法師專集網',
              keywords: '淨空老法師,無量壽經',
              description: '淨空老法師專集網報恩講堂',
              icon: '/static/images/unesco_mjk.jpg',
              url: window.location.href
            }
          }
        },
        {path: '/privacy', name: 'privacy', component: Privacy}
      ]
    },
    {path: '/sharepage', name: 'sharepage', component: Sharepage},
    {path: '*', redirect: '/home'}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js